import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/react'
import { useNavigate } from 'react-router-dom'

import { useContributions, usePhoto } from '@hooks/index'
import useStudents from '@hooks/useStudents'
import useContacts from '@hooks/useContacts'
import useSession from '@hooks/useSession'
import { getContributionURL } from '@/util/helpers'
import { sendInviteMoreClickedEvent } from '@/services/analytics/gtm'

import Spinner from '@components/Spinner'
import Section from '@components/Section'
import InvitationList from '@/components/InvitationList'
import ContributionList from '@/components/ContributionList'
import ParticipationStatus from '@/components/ParticipationStatus'
import ContributionProgressBar from '@/components/ProgressBars/ContributionProgressBar'
import PrizeProgressBar from '@components/ProgressBars/PrizeProgressBar'
import Button from '@/components/Button'

export default function ProgressPage() {
  const { t } = useTranslation()
  const { session } = useSession()
  const navigate = useNavigate()

  //pre-fetch data
  usePhoto()
  const { students, isLoading: isLoadingStudents } = useStudents()
  const { contacts, isLoading: isLoadingContacts } = useContacts()
  useContributions()

  if (!session || isLoadingContacts || isLoadingStudents) {
    return (
      <div className='flex flex-col items-center justify-center py-56'>
        <div className='text-xl font-serif text-white mb-4 '> Signing In...</div>
        <Spinner />
      </div>
    )
  }

  if (!contacts || !students) {
    Sentry.logger.error('No contacts or students found on Progress page')
    navigate(`/${session.schoolSlug}`)
  }

  return (
    <>
      <title>Progress Tracker - Book Blast by Books Are Fun</title>
      <div className='w-full'>
        <div className='bg-cta text-center px-4 md:px-8'>
          <h1 className='text-white text-3xl font-serif text-center font-bold'>{t('content.progress_page.title')}</h1>
          <div className='text-white pt-2'>{t('content.progress_page.subtitle')}</div>
        </div>

        <ParticipationStatus />

        <Section wrapperStyle='mt-16' title={t('content.components.current_contributions.title')}>
          <ContributionProgressBar />
          <ContributionList />
          <div className='pt-6'>
            <Button
              fullwidth
              label={t('content.components.current_contributions.contribute_button_title')}
              variant='cta'
              onClick={() => window.open(getContributionURL(session.schoolSlug, session.parentSlug), '_blank')}
            />
          </div>
        </Section>

        <Section wrapperStyle='mt-16 mb-4'>
          <InvitationList />
          <PrizeProgressBar />

          <div className='pt-10'>
            <Button
              fullwidth
              label={t('content.components.current_contacts.invite_button_title')}
              variant='cta'
              onClick={() => {
                sendInviteMoreClickedEvent('your_contacts_section')
                navigate('../invite')
              }}
            />
          </div>
        </Section>
      </div>
    </>
  )
}
